import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setMoreRulesPopoverShow } from '../../store/modals/moreRulesPopover.slice'

export const connectMoreRulesPopover = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      setMoreRulesPopoverShow,
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
